module.exports = __webpack_public_path__ + "img/Banner_dashboard.5445fa21.svg";